export default [
  {
    title: 'Auth',
    group: 'auth',
    component: 'auth',
    section: 'store',
    order: 0,
    icon: 'verified_user',
    items: [
      {
        title: 'Users',
        group: 'users',
        component: 'users',
        section: 'store'
      },
      {
        title: 'Roles',
        group: 'roles',
        component: 'roles',
        section: 'store'
      },
      {
        title: 'Permissions',
        group: 'permissions',
        component: 'permissions',
        section: 'store'
      }
    ]
  }
]
